
import { RevButtonTiny, RevCardCarousel } from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import translations from '../../helpers/translations/cardSlider.translations'
import { ArticleCard } from '../private/ArticleCard'
import BlockTitle from '../private/BlockTitle'

import translationsPressCarousel from './PressCarousel.translations'
import { pressArticlesValidator } from './PressCarousel.validators'

export default {
  components: {
    RevButtonTiny,
    BlockTitle,
    RevCardCarousel,
    ArticleCard,
  },
  props: {
    articles: {
      type: Array,
      default: () => [],
      validator: pressArticlesValidator,
    },
    subtitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    translations: () => ({
      ...translations,
      ...translationsPressCarousel,
    }),
    ...mapGetters({
      pressLink: 'config/press',
    }),
    hasArticles() {
      return !isEmpty(this.articles)
    },
    hasPressLink() {
      return !isEmpty(this.pressLink)
    },
    hasTitle() {
      return !isEmpty(this.title)
    },
    isHeadingVisible() {
      return this.hasPressLink || this.hasTitle
    },
  },
  methods: {
    // TODO: Should be updated as part of GNL-2858
    tracking({ position = '', slideIndex }) {
      return {
        name: [slideIndex, position].join('-'),
      }
    },
    getLoadingAttribute(index) {
      return index === 0 ? 'eager' : 'lazy'
    },
  },
}
